import React from 'react'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'
import styled, { injectGlobal } from 'styled-components'

import Header from '../components/header'

injectGlobal`
  *, *::before, *::after {
    box-sizing: border-box;
  }

  :root {
    font-size: 10px;
  }

  body {
    margin: 0;
    padding: 0;
    font-family: -apple-system, BlinkMacSystemFont, "Helvetica Neue", "Roboto", sans-serif;
    text-rendering: optimizeLegibility;
    -webkit-font-smoothing: antialiased;
    font-size: 2rem;
    overflow-x: hidden;
    max-width: 100vw;
  }
  a {
    color: blue;
  }
  p {
    margin: 0
  }
`

const StyledFooter = styled.footer`
  padding: 4rem;
  padding-top: 0;
  display: flex;
  justify-content: space-between;
  @media(max-width: 500px) {
    padding: 2rem;
    padding-top: 0;
    font-size: 0.7em
  }
`

const Layout = ({ children, data }) => (
  <div>
    <Helmet
      title={data.site.siteMetadata.title}
      meta={[
        { name: 'description', content: "🎨 I\'m an artist based in Newcastle, Australia. My work mainly consists of: digital, glitch, collage, CGI, 3D, and AI." },
        { name: 'keywords', content: 'lachie, art, glitch art, cgi, 3d, digital, collage, newcastle, australia' },
      ]}
    />
    <Header/>
    <div>
      {children()}
    </div>
    <StyledFooter>
      <p><a href="https://lachie.co">lachie.co</a></p>
      <p>site by <a href="https://lach.io" target="_blank">lach</a></p>
    </StyledFooter>
  </div>
)

Layout.propTypes = {
  children: PropTypes.func,
}

export default Layout

export const query = graphql`
  query SiteTitleQuery {
    site {
      siteMetadata {
        title
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/layouts/index.js